export default `
<div  class="img-crop" ng-class="{clickable: $ctrl.isBigger}" ng-click="$ctrl.showFullImage()" ng- role="button" tabindex="0" ng-keydown="$ctrl.showFullImageByKeydown($event)" aria-label="{{$ctrl.isBigger ? 'Click to view full image' : ''}}">
  <img src="{{$ctrl.src}}" alt="{{$ctrl.alt}}" >
  <div class="img-crop-footer"></div>
</div>
`;
